export const DEFAULT_MODEL_INTEREST_OPTIONS = [
  { value: "id_ao3_primint", label: "911" },
  { value: "id_ao1_primint", label: "Boxster" },
  { value: "id_ao2_primint", label: "Cayman" },
  { value: "id_ao4_primint", label: "Cayenne" },
  { value: "id_ao4_primint.X1AAA1", label: "Cayenne Electric" },
  { value: "id_ao8_primint", label: "Macan" },
  { value: "id_ao8_primint.XABAA1", label: "Macan Electric" },
  { value: "id_ao5_primint", label: "Panamera" },
  { value: "id_ao9_primint", label: "Taycan" },
];

export const MODEL_INTEREST_OPTIONS = DEFAULT_MODEL_INTEREST_OPTIONS;

export const normalizeModelInterestCatalog = (options) => {
  if (!Array.isArray(options)) {
    return [];
  }

  const seen = new Set();
  return options
    .map((item) => {
      const value = String(item?.value || item?.model || "").trim();
      const label = String(item?.label || item?.description || value).trim();
      if (!value || seen.has(value)) {
        return null;
      }
      seen.add(value);
      return { value, label: label || value };
    })
    .filter(Boolean);
};

export const resolveModelInterestCatalog = (stored) => {
  if (stored == null) {
    return DEFAULT_MODEL_INTEREST_OPTIONS.map((option) => ({ ...option }));
  }
  return normalizeModelInterestCatalog(stored);
};

export const getModelInterestValue = (itemOrValue) => {
  if (itemOrValue == null || itemOrValue === "") {
    return "";
  }
  if (typeof itemOrValue === "string") {
    return itemOrValue;
  }
  return itemOrValue.value || itemOrValue.model || "";
};

export const getModelInterestLabel = (
  itemOrValue,
  catalog = DEFAULT_MODEL_INTEREST_OPTIONS,
) => {
  const value = getModelInterestValue(itemOrValue);
  const match = resolveModelInterestCatalog(catalog).find(
    (option) => option.value === value,
  );
  if (match) {
    return match.label;
  }
  if (itemOrValue && typeof itemOrValue === "object") {
    return itemOrValue.label || itemOrValue.description || value;
  }
  return value;
};

export const normalizeModelInterestSelection = (
  modelsSelected,
  catalog = DEFAULT_MODEL_INTEREST_OPTIONS,
) => {
  if (!Array.isArray(modelsSelected)) {
    return [];
  }

  const resolvedCatalog = resolveModelInterestCatalog(catalog);
  const seen = new Set();
  return modelsSelected
    .map((item) => {
      const value = getModelInterestValue(item);
      if (!value || seen.has(value)) {
        return null;
      }
      seen.add(value);
      const match = resolvedCatalog.find((option) => option.value === value);
      return (
        match || {
          value,
          label: getModelInterestLabel(item, resolvedCatalog),
        }
      );
    })
    .filter(Boolean);
};

export const getVisibleModelInterestOptions = (
  modelsSelected,
  currentValue,
  catalog = DEFAULT_MODEL_INTEREST_OPTIONS,
) => {
  const resolvedCatalog = resolveModelInterestCatalog(catalog);
  const selected = normalizeModelInterestSelection(
    modelsSelected,
    resolvedCatalog,
  );
  const selectedValues = new Set(selected.map((item) => item.value));
  const catalogOptions =
    selected.length === 0
      ? [...resolvedCatalog]
      : resolvedCatalog.filter((option) => selectedValues.has(option.value));
  const extras = selected.filter(
    (item) =>
      !resolvedCatalog.some((option) => option.value === item.value),
  );
  const visible = [...catalogOptions, ...extras];
  const current = getModelInterestValue(currentValue);

  if (
    current &&
    current !== "--" &&
    !visible.some((option) => option.value === current)
  ) {
    visible.push({
      value: current,
      label: getModelInterestLabel(current, resolvedCatalog),
    });
  }

  return visible;
};
